var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNodeIcon = function SvgNodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.367 9.9v2.6h7.267V9.9zm-.5-1.5a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h8.267a1 1 0 0 0 1-1V9.4a1 1 0 0 0-1-1zM2.367 1.5v2.6h7.267V1.5zm-.5-1.5a1 1 0 0 0-1 1v3.6a1 1 0 0 0 1 1h8.267a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.533 8.4V4.667h.934V8.4z",
    clipRule: "evenodd"
  })));
};
export default SvgNodeIcon;